import React from 'react';
import PropTypes from 'prop-types';

const Deactivate = ({ color = '#B5BDC5' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/-activate"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <path
                d="M7.82932202,1.19159542 C7.82932202,0.533436355 8.35319711,-3.55271368e-15 8.9995594,-3.55271368e-15 C9.64592168,-3.55271368e-15 10.1697968,0.533436355 10.1697968,1.19159542 L10.1697968,7.4568929 C10.1697968,8.11505197 9.64592168,8.64848832 8.9995594,8.64848832 C8.35319711,8.64848832 7.82932202,8.11505197 7.82932202,7.4568929 L7.82932202,1.19159542 Z M8.9995594,18 C4.58825797,18 1,14.3458039 1,9.85444032 C1,6.99793126 2.49848543,4.31459834 4.91121881,2.85202263 C5.46681721,2.5146432 6.18499752,2.6999327 6.51588919,3.26611999 C6.84678086,3.83185863 6.66437187,4.56314648 6.10921408,4.90007727 C4.40188357,5.93554498 3.34091535,7.83420154 3.34091535,9.85488896 C3.34091535,13.0321777 5.87966074,15.6172578 9,15.6172578 C12.1203393,15.6172578 14.6590847,13.0321777 14.6590847,9.85488896 C14.6590847,7.83330425 13.5981164,5.93464769 11.8899047,4.89917998 C11.3343063,4.5622492 11.1518973,3.83096134 11.482789,3.2652227 C11.8127995,2.6999327 12.5314204,2.51419456 13.0870188,2.8506767 C15.501074,4.31370105 17,6.99703397 17,9.85444032 C16.9991188,14.3458039 13.4108608,18 8.9995594,18 Z"
                id="Shape"
                fill={color}
                className="icon-color"
            />
        </g>
    </svg>
);

Deactivate.propTypes = {
    color: PropTypes.string,
};

export default Deactivate;
